 
 
 
 
 
 
/**
 * @ignore
 * Action button representing a single entry point in the context of 'Route to entry point' and 'Route from entry point'
 * actions.
 */
define([
    'leaflet',
    './actionButton',
    '../details/addressContainer',
    '../wrapable'
], function(
    L,
    actionButton,
    addressContainer,
    Wrapable
) {
    'use strict';
    var classes = {
        mainPanel: 'tomtom-point-content__entry-points-action',
        entryPointsAnchorPanel: 'tomtom-point-content__anchor-panel',
        entryPointsPanel: 'tomtom-point-content__entry-points',
        entryPointsPanelHidden: 'tomtom-point-content__entry-points--hidden',
        entryPoint: 'tomtom-point-content__entry-point',
        entryPointWithBorder: 'tomtom-point-content__entry-point--with-border',
        entryPointFirst: 'tomtom-point-content__entry-point--first',
        entryPointLast: 'tomtom-point-content__entry-point--last'
    };

    function isEntryPointsListVisible(classList) {
        return !classList.contains(classes.entryPointsPanelHidden);
    }

    function hideEntryPoints(entryPointsPanel) {
        entryPointsPanel.classList.add(classes.entryPointsPanelHidden);
    }

    function toggleEntryPointsVisibility(entryPointsPanel, onEntryPointsUnfold) {
        if (isEntryPointsListVisible(entryPointsPanel.classList)) {
            hideEntryPoints(entryPointsPanel);
        } else {
            onEntryPointsUnfold();
            entryPointsPanel.classList.remove(classes.entryPointsPanelHidden);
        }
    }

    function createEntryPointsList(
        mode,
        entryPoints,
        entryPointClickHandler,
        entryPointMouseoverHandler,
        entryPointMouseoutHandler
    ) {
        var addressPromises,
            entryPointsPanel = L.DomUtil.create('div', classes.entryPointsPanel),
            hideEntryPointsBound = hideEntryPoints.bind(null, entryPointsPanel);

        addressPromises = entryPoints.map(function(entryPoint) {
            return entryPoint.getAddress()
                .then(function(addressPoint) {
                    return {
                        entryPoint: entryPoint,
                        addressPoint: addressPoint
                    };
                });
        });

        Promise.all(addressPromises).then(function(entryAddressPoints) {
            entryAddressPoints.reduce(function(container, entryAddressPoint, addressPointIndex) {
                var entry = addressContainer(entryAddressPoint.addressPoint.address),
                    entryPosition = entryAddressPoint.entryPoint.position;
                entry.classList.add(classes.entryPoint);

                if (addressPointIndex === 0) {
                    entry.classList.add(classes.entryPointFirst);
                } else {
                    entry.classList.add(classes.entryPointWithBorder);
                }

                if (addressPointIndex === entryAddressPoints.length - 1) {
                    entry.classList.add(classes.entryPointLast);
                }

                if (entryPointMouseoverHandler) {
                    entry.addEventListener('mouseover', entryPointMouseoverHandler.bind(entry, entryPosition));
                }

                if (entryPointMouseoutHandler) {
                    entry.addEventListener('mouseout', entryPointMouseoutHandler.bind(entry, entryPosition));
                }

                container.appendChild(entry);
                if (entryPointClickHandler) {
                    entry.addEventListener('click', function() {
                        hideEntryPointsBound();
                        entryPointClickHandler.call(entry, mode, entryPosition);
                    });
                }
                return container;
            }, entryPointsPanel);
        });

        return entryPointsPanel;
    }

    /**
     * @ignore
     * @param {Object} options
     * @param {String} options.label Text label
     * @param {String} options.mode Button routing mode. It might be either 'start' or 'end'
     * @param {Object} options.entryPoints The list of entry points.
     * @param {Function} options.onEntryPointsUnfold
     * @param {Function} options.onEntryPointClick
     * @param {Function} options.onEntryPointMouseover
     * @param {Function} options.onEntryPointMouseout
     * @return {Wrapable}
     */
    return function(options) {
        var mainPanel,
            entryPointsAnchorPanel,
            label = options.label,
            mode = options.mode,
            entryPoints = options.entryPoints,
            onEntryPointsUnfold = options.onEntryPointsUnfold,
            onEntryPointClick = options.onEntryPointClick,
            onEntryPointMouseover = options.onEntryPointMouseover,
            onEntryPointMouseout = options.onEntryPointMouseout,
            action;

        function actionsButtonClickHandler() {
            var entryPointsAlreadyAdded = Boolean(entryPointsAnchorPanel.children.length),
                entryPointsPanel,
                entryPointsPanelIndex = 0;

            if (!entryPoints || !entryPoints.length) {
                return;
            }

            if (entryPointsAlreadyAdded) {
                toggleEntryPointsVisibility(
                    entryPointsAnchorPanel.children[entryPointsPanelIndex], onEntryPointsUnfold
                );
            } else {
                onEntryPointsUnfold();
                entryPointsPanel = createEntryPointsList(
                    mode, entryPoints, onEntryPointClick, onEntryPointMouseover, onEntryPointMouseout
                );
                entryPointsAnchorPanel.appendChild(entryPointsPanel);
            }

        }

        action = actionButton('icon-' + mode + '-black', label, actionsButtonClickHandler);

        mainPanel = L.DomUtil.create('div', classes.mainPanel);
        mainPanel.appendChild(action);
        entryPointsAnchorPanel = L.DomUtil.create('div', classes.entryPointsAnchorPanel, mainPanel);

        return new Wrapable(mainPanel, function(mainPanel) {
            var entryPointsAnchorPanelIndex = 1,
                entryPointsPanelIndex = 0,
                entryPointsAnchorPanel = mainPanel.children[entryPointsAnchorPanelIndex],
                entryPointsAlreadyAdded = Boolean(entryPointsAnchorPanel.children.length),
                entryPointsPanel;
            if (!entryPointsAlreadyAdded) {
                return;
            }
            entryPointsPanel = entryPointsAnchorPanel.children[entryPointsPanelIndex];
            if (!entryPointsPanel.classList.contains(classes.entryPointsPanelHidden)) {
                entryPointsPanel.classList.add(classes.entryPointsPanelHidden);
            }
        });
    };
});



// WEBPACK FOOTER //
// ./services/popupContentGenerator/actions/entryPointsButton.js